module.exports = __webpack_public_path__ + "static/media/machine-back.843e7910.png";